module.exports = __webpack_public_path__ + "img/flexible_store.b7f09da4.svg";